import { ModBoss } from '@vp/mod-father';
import { useContext } from 'react';
import { modFatherTracker as hostTracker } from '../../apis/trackingApi';
import { PageModsContext } from '../contexts/PageModsProvider';
import {
  commonVpDependenciesV1,
  orderInfoV1,
  orderInfoV2,
} from '../../utils/uxModContracts';
import { useSiteData } from '../../hooks/useSiteData';
import { useOrderSummary } from '../contexts/OrderSummaryContext';

interface HistoryOrderUxModWrapperProps {
  children: React.ReactNode;
}

/**
 * This component handles injection of mods on the Order Level.
 * Such mods can either be from site configuration, with a 'order' scope,
 * or be attached to the `Order` objects via customOrderData.
 *
 * @param {*} children
 * @param {*} order - the specific order (from a list of orders) which to wrap with a ModBoss and mods.
 */
export const HistoryOrderUxModWrapper = ({
  children,
}: HistoryOrderUxModWrapperProps) => {
  const { order } = useOrderSummary();

  const { vistacartTenant } = useSiteData();

  const { activeOrderLevelPageUxMods: orderUxMods } = useContext(
    PageModsContext
  ) || { activeItemGroupLevelPageUxMods: [] };

  const environmentData = order
    ? {
        orderInfoV1: orderInfoV1(order, vistacartTenant),
        orderInfoV2: orderInfoV2(order, vistacartTenant),
        commonVpDependenciesV1,
      }
    : {};

  const orderAttachedMods = order.customOrderData.ux || [];

  return (
    <ModBoss
      mods={[...(orderUxMods || []), ...(orderAttachedMods || [])]}
      environmentData={environmentData}
      contextKey={order.orderNumber}
      hostTracker={hostTracker}
    >
      {children}
    </ModBoss>
  );
};
